import React, { useEffect, useState } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import { upload } from '../../store/actions/vendor/Vendor';
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import {
  getSubCategoryDetails,
  getAllCategory as getAllCategoryList,
  getCategory as getCategoryList,
  updateSubCategory
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const SubCategoryEdit = (props) => {
  const classes = useStyles();
  const [imageUploadMessage, updateImageUploadMessage] = useState('');
  const [subCategoryDetail, updateSubCategoryDetail] = useState(
    props.subCategoryDetails
  );

  useEffect(() => {
    const superCategoryId = props.match.params.superCategoryId;
    const categoryId = props.match.params.categoryId;
    const subCategoryId = props.match.params.subCategoryId;
    props.getSubCategoryDetails(categoryId, subCategoryId);
    props.getAllCategoryList(superCategoryId);
    props.getCategoryList(superCategoryId);
  }, []);

  useEffect(() => {
    if (props?.subCategoryDetails) {
      const tempSubCategoryDetail = {
        superCategoryId: props.subCategoryDetails.superCategoryId,
        subCategoryId: props.subCategoryDetails.id,
        categoryId: props.subCategoryDetails.categoryId,
        name: props.subCategoryDetails.name,
        icon: props.subCategoryDetails.icon
      };
      updateSubCategoryDetail(tempSubCategoryDetail);
    }
  }, [props?.subCategoryDetails]);

  const onChange = (event) => {
    let tempSubCategoryDetail = { ...subCategoryDetail };
    tempSubCategoryDetail[event.target.name] = event.target.value;
    updateSubCategoryDetail(tempSubCategoryDetail);
  };

  const onUpload = (event) => {
    updateImageUploadMessage('Uploading the file, please wait...');
    let data = new FormData();
    data.append('files', event.target.files[0]);
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateImageUploadMessage('File uploaded successfully.');
          let tempSubCategoryDetail = { ...subCategoryDetail };
          tempSubCategoryDetail.icon = `${response.data.uploads[0].path}`;
          updateSubCategoryDetail(tempSubCategoryDetail);
        } else {
          updateImageUploadMessage('Please, try Again');
        }
      })
      .catch((error) => {
        updateImageUploadMessage(
          'An error occurred while executing the query. Please try Again'
        );
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    props.updateSubCategory(subCategoryDetail).then((data) => {
      if (data) {
        props.history.push(
          `/admin/sub-category/${subCategoryDetail.subCategoryId}/${subCategoryDetail.categoryId}`
        );
      }
    });
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Update a SubCategory</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="SubCategory Name"
              value={subCategoryDetail?.name}
              onChange={onChange}
              name="name"
              id="name"
              labelProps={{
                shrink: true
              }}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="SubCategory Icon"
              id="icon"
              type="file"
              name="icon"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onUpload}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <br />
          <p style={{ color: '#000' }}>{imageUploadMessage}</p>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: '#fff',
            backgroundColor: '#9c27b0',
            boxShadow:
              '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
          }}
        >
          Update SubCategory
        </Button>
      </CardFooter>
      <br /> <br />
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Super Category</th>
            <th>Category</th>
            <th>Icon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>1</th>
            <td>{subCategoryDetail?.name}</td>
            {props.superCategories
              .filter(
                (categorieFilter) =>
                  categorieFilter.id === subCategoryDetail?.superCategoryId
              )
              .map((type) => (
                <td key={type.id}>{type.name}</td>
              ))}
            {props.categories
              .filter(
                (categorieFilter2) =>
                  categorieFilter2.id === subCategoryDetail?.categoryId
              )
              .map((type2) => (
                <td key={type2.id}>{type2.name}</td>
              ))}
            <td>
              <img
                src={subCategoryDetail?.icon}
                style={{ height: '70px' }}
                alt=""
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  subCategoryDetails: state.admin.subCategoryDetails,
  categories: state.admin.categories,
  superCategories: state.admin.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getAllCategoryList: (superCategoryId) =>
      dispatch(getAllCategoryList(superCategoryId)),
    getSubCategoryDetails: (categoryId, subCategoryId) =>
      dispatch(getSubCategoryDetails(categoryId, subCategoryId)),
    updateSubCategory: (categoryData) =>
      dispatch(updateSubCategory(categoryData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(SubCategoryEdit);
